/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvc3RhdGlzdGljcy9kb25hdGlvbi9yYXctZGF0YS1zaG9wLWdpdmluZ3MvcmF3LWRhdGEtc2hvcC1naXZpbmdzLmNvbXBvbmVudC5zY3NzIn0= */"];
export { styles as styles };
